import React,{Component} from 'react';
import {PostData} from '../../../service/postData';
import {sendNotification} from '../../../_notificationSettings/notificationPanel';
import { MDBDataTableV5 } from 'mdbreact';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';

global.BACK_URL = 'Company';

let columns = [
    {
        label: '#',
        field: 'srNo',
        width: 20,
        attributes: {
        'aria-controls': 'DataTable',
        'aria-label': '#',
        },
    },
    {
        label: 'Unit Name',
        field: 'unit_name',
        width: 150
    },
    {
        label: 'Unit Slug',
        field: 'slug',
        width: 150
    },
    {
        label: 'Status',
        field: 'status',
        width: 100,
    },
    {
        label: 'Action',
        field: 'action',
        width: 100,
    }
];

let _loader = 'glb-ldr-prt active';

export default class companyListPanel extends Component{
    constructor(props){
        super(props);
        this.state = {
            buttonTitle:'Add New',
            isLoaded : true,
            unit_name : null,
            slug : null,
            gstArray : [],
            unitId : 0,
            errors: {
                unit_name : '',
                slug: ''
            }
        }
    }

    async componentDidMount ()
    {
        /* Get Url Pass Parameter */
        let _handleParam = this.props.location.search;
        _handleParam = _handleParam.split('?auth=');
        let _unitId = _handleParam[1] ? _handleParam[1] : 0;
        /* End Here Url Pass Parameter */

        if(_unitId > 0){
            let _gstArray = [];
            let _url_GetData = global.unitDetails+'?unitId='+_unitId;
            PostData(_url_GetData,'','GET').then(result => {
                let responseJson = result;
                if(responseJson.success == false)
                {  
                    this.setState({isLoaded:true});                
                }
                else
                {
                    if (responseJson.response) {
                        _gstArray = responseJson.response[0];
                        this.setState({buttonTitle:'Edit',unit_name:_gstArray.unit_name,unitId:_gstArray.unit_id,slug:_gstArray.slug,isLoaded:true});
                    }
                }             
            })
            .catch(error => this.setState({ error, isLoaded: false }));
        }
        this.getGstListData();
    }

    getGstListData(){
        let _gstArray = [];

        let _url_GetData = global.unitList;
        PostData(_url_GetData,'','GET').then(result => {
            let responseJson = result;
            if(responseJson.success == false)
            {  
                this.setState({isLoaded:true});                
            }
            else
            {
                if (responseJson.response) {
                    _gstArray = responseJson.response;
                }
                this.setState({gstArray:_gstArray,isLoaded:true});               
            }             
        })
        .catch(error => this.setState({ error, isLoaded: false }));
    }

    handleChange = (event) => {
        event.preventDefault();
        const { name, value } = event.target;
        let errors = this.state.errors;
        this.setState({isDisabled:false});
        switch (name) {
            case 'unit_name': 
            errors.unit_name = 
                value.length < 3 ? '*GST Name must be 3 characters long!' : '';
                this.setState({unit_name:value}); 
            break;
            case 'slug': 
            errors.slug = 
                value < 0 ? '*GST Ratio must be 0 or greater than 0!' : '';
                this.setState({slug:value}); 
            break;
            default:
            break;
        }
    }

    clickToAddGst = (event) => {
        event.preventDefault();
        let errors = this.state.errors;
        //console.log(errors);
        let _isError = false;
        if(this.state.unit_name == null)
        {
            _isError = true;
            errors['unit_name'] = "*Please Enter Unit Name";
            this.setState({errors: errors});
        }
        if(this.state.slug == null)
        {
            _isError = true;
            errors['slug'] = "*Please Enter Slug";
            this.setState({errors: errors});
        }
        

        if(_isError == false){
            if(this.state.unitId > 0){
                this.editGstMethodCall();
            }
            else{
                this.addGstMethodCall();
            }
        }
    }

    editGstMethodCall()
    {
        const requestData = JSON.stringify({
            unit_name: this.state.unit_name,
            slug: this.state.slug,
            unitId: this.state.unitId
        });
        PostData(global.adminEditUnit, requestData,'POST').then((result) => {
            if(result.success == true)
            {
                sendNotification("Success Message 👍",result.message,"success");
                setTimeout(
                    () => {
                        window.location.href = global.webUrl+'administrator/manage-unit/';
                    }, 
                    Math.floor(Math.random() * 5000) + 1
                )
            }
            else
            {
                sendNotification("Error Message 😓",result.message,"danger");
                let errors = this.state.errors;
                errors['unit_name'] = result.message;
                this.setState({
                    errors:errors
                })
                return;
            }
        });
    }

    addGstMethodCall(){
        const requestData = JSON.stringify({
            unit_name: this.state.unit_name,
            slug: this.state.slug,
        });

        PostData(global.adminAddUnit, requestData,'POST').then((result) => {
            if(result.success == true)
            {
                sendNotification("Success Message 👍",result.message,"success");
                setTimeout(
                    () => {
                        window.location.href = global.webUrl+'administrator/manage-unit/';
                    }, 
                    Math.floor(Math.random() * 5000) + 1
                )
            }
            else
            {
                sendNotification("Error Message 😓",result.message,"danger");
                let errors = this.state.errors;
                errors['unit_name'] = result.message;
                this.setState({
                    errors:errors
                })
                return;
            }
        });
    }

        clickToStatus(value,_status)
        {
            confirmAlert({
                title: 'Confirm to manage status',
                message: 'Are you sure you want to change the status?',
                buttons: [
                { 
                    label: 'Yes',
                    className: 'btn btn-danger',
                    onClick: () => {
                        const requestData = JSON.stringify({
                            unitId: value,
                            status:_status
                        });
                        PostData(global.adminUnitStatus, requestData,'POST').then((result) => {
                            let responseJson = result;                
                            if(responseJson.success == false)
                            {
                                sendNotification("Error Message 😓",responseJson.message,"danger");
                                return;
                            }
                            else
                            {
                                sendNotification("Welcome Back  👍",responseJson.message,"success");
                                this.getGstListData();
                                return;
                            }
                        });
                    }
                },
                {
                    label: 'No',
                    className: 'btn btn-dark',
                }
                ]
            });
        }

    loadOrderListing()
    {   
        if(this.state.isLoaded == true)
        {
            let _gstDetails = this.state.gstArray;
            let dataList = [];
            let rows = [];

            if(_gstDetails.length > 0)
            {                          
                _gstDetails.map((compDatas, i) =>
                {
                    const row = compDatas;
                    
                    let _status = 1;
                    let status = <span className={`badge badge-danger`}>Disabled</span>;
                    if (row.status == '1' || row.status == 1) {
                        _status = 0;
                        status = <span className={`badge badge-success`}>Enabled</span>;
                    } 
                    rows.push({
                        unit_name: row.unit_name,
                        slug: row.slug,
                        srNo: row.srNo,
                        status: (status),
                        action:(
                            <div className="btn-group" role="group">
                                <button type="button" className="btn btn-secondary dropdown-toggle" id="btnGroupVerticalDrop3" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                    <i className="si si-list"></i>
                                </button>
                                <div className="dropdown-menu" aria-labelledby="btnGroupVerticalDrop1">
                                    <a className="dropdown-item" href={global.webUrl+'administrator/manage-unit/?auth='+row.unit_id}>
                                        <i className="si si-pencil mr-5 text-info"></i>Edit Details
                                    </a>
                                    <a className="dropdown-item" href="javascript:void(0)" data-id={row.id} onClick={this.clickToStatus.bind(this,row.unit_id,_status)}>
                                        <i className="fa fa-exclamation-triangle mr-5 text-primary"></i>Manage Status
                                    </a>
                                </div>
                            </div>
                        )
                    });
                })
            }

            if (rows) {
                dataList = {
                    columns: columns,
                    rows: rows
                };
            }
            return dataList;
        }
    }

    render(){
        if(this.state.isLoaded == true){
            _loader = 'glb-ldr-prt';
        }
        
        const {errors} = this.state;
        const isDisabled = Object.keys(errors).some(x => errors[x]);
        return(
            <React.Fragment>
                <div className="content">
                    <div className="content-header">
                        <div className="header-section">
                            {/* <h2 className="content-heading">Manage Business</h2> */}
                            <h1 className="content-heading">
                                <i className="gi gi-direction"></i>Manage Unit List<br/>
                            </h1>
                        </div>
                    </div>
                    <nav className="breadcrumb push">
                        <a className="breadcrumb-item" href={global.webUrl+"administrator/dashboard/"}>Dashboard</a>
                        <span className="breadcrumb-item active">Manage Unit List</span>
                    </nav>
                    
                    <div className="block">
                        <div className="block-header block-header-default">
                            <h3 className="block-title">Add / Edit Unit</h3>
                        </div>
                        <div className="block-content">
                            <form method="post" id="form-login" className="webForm px-30">
                                <div className="form-group row">
                                    <div className="col-6">
                                        <div className="form-material open">
                                            <input type="text" required="required" className="form-control" id="unit_name" name="unit_name" value={this.state.unit_name} placeholder="Unit Name Here" onChange={this.handleChange}/>
                                            <label htmlFor="login-username">Unit Name <span className="text-danger">*</span></label>
                                            <span className="iris_error_txt">{errors.unit_name.length > 0 && <span className='error'>{errors.unit_name}</span>}</span>
                                        </div>
                                    </div>
                                    <div className="col-6">
                                        <div className="form-material open">
                                            <input type="text" required="required" className="form-control" id="slug" name="slug" value={this.state.slug} placeholder="Unit Slug Here" onChange={this.handleChange}/>
                                            <label htmlFor="login-username">Unit Slug <span className="text-danger">*</span></label>
                                            <span className="iris_error_txt">{errors.slug.length > 0 && <span className='error'>{errors.slug}</span>}</span>
                                        </div>
                                    </div>
                                </div>
                                
                                <div className="form-group row">
                                    <div className="col-12">
                                        <button type="submit" disabled={isDisabled} className="btn btn-alt-primary" onClick={this.clickToAddGst}>
                                            <i className="fa fa-check mr-5"></i> {this.state.buttonTitle} Unit
                                        </button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>

                    <div className="block">
                        <div className="block-header block-header-default">
                            <h3 className="block-title">List of Unit</h3>
                        </div>
                        <div className="block-content">
                            <MDBDataTableV5 
                            hover
                            entriesOptions={[25, 50, 100, 200, 500, 1000]}
                            entries={25}
                            pagesAmount={4}
                            span
                            //pagingTop
                            searchTop
                            searchBottom={false}
                            barReverse
                            data={this.loadOrderListing()} />
                        </div>
                    </div>    
                </div>
                
                <div id="global_loader" className={_loader}>
                    <div class="gl-ldr-cld">
                        <div class="gl-ldr-ctr">
                            <div class="gl-loader"></div>
                        </div>
                    </div>
                </div>
            </React.Fragment>
        )    
    }
}